import { useContext, useRef } from "react";
import { RadioGroupContext } from "$contexts/RadioGroupContext";

export const RadioButton = ({className="", checked, onNewValue, children, style, ...props}) => {
    const inputRef = useRef();
    // make checkbox click in enter (by default only changes with space and that is taken for audio play/stop)
    function handleKeyDown (e) {
        if (e.key !== "Enter") return;
        inputRef.click();
    }
    const { name } = useContext(RadioGroupContext);
    // keyboard navigation: radiogroups set moving between buttons of the same group with arrow keys
    return ( 
        <label {...props} className={`${className} radiobutton btn ${checked ? "active" : ""}`} style={style}>
            <input ref={inputRef}
                type="radio"
                name={name}
                checked={checked}
                onChange={e => onNewValue(e.target.checked, e)}
                onKeyDown={handleKeyDown}
            />
            <span>{children}</span> 
        </label>
    );
}